// Controls which storage solution we need to use based on if the extension is in
// embed mode or extension mode
//
// https://en.wikipedia.org/wiki/Lazarette

import { isExtension } from '../../helpers/build'
import { widgetMode } from '../../constants/env'
import chromeAdapter from './adapters/chromeStorageAdapter'
import localStorageAdapter from './adapters/localStorageAdapter'

const adapter = isExtension(widgetMode) ? chromeAdapter : localStorageAdapter

// Gets one or more items from storage
//
// Params
//
// keys: string | string[]
const get = keys => {
  return adapter.get(keys)
}

// Sets multiple items
//
// Params:
//
// items: object
const set = items => {
  return adapter.set(items)
}

// Remove one or more items from storage.
//
// Params:
//
// keys: string | string[]
const remove = keys => {
  return adapter.remove(keys)
}

const lazarette = {
  get,
  set,
  remove
}

export default lazarette
